"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilters = void 0;
var browser_1 = require("@cian/config/browser");
function getFilters() {
    var filterStrings = (0, browser_1.getConfig)().get('logger.browser.errorFilter');
    return (filterStrings || []).map(function (filterString) { return new RegExp(filterString); });
}
exports.getFilters = getFilters;
//# sourceMappingURL=getFilters.js.map